export default __webpack_public_path__ + "static/pomello@2x-dc634f412f845358d7a2bd1498ee40a9.png";